<div
  class="row justify-content-center"
  id="BenefitsCardPushComponent_{{pageTemplate.charAt(0).toUpperCase() + pageTemplate.slice(1).toLowerCase()}}Page_1"
>
  <div class="col-24 col-m-20">
    <sd-component-wrapper [content]="wrapperContent" [titleLevel]="3" [themesConfig]="lameConfig?.backgroundTheme">
      @if (table?.entries?.length > 0) {
        <ng-container sd-component-wrapper-component>
          <sd-form-input
            (inputChanged)="onEmit($event)"
            [placeholder]="'accessory.designedFor.search' | translate"
          />
          <div class="c__how-to-find row justify-content-center">
            <a (click)="openModalRef()">
              <sd-icon name="icon-help" [size]="iconSize.xs" />
              {{ 'accessory.designedFor.referenceLink' | translate }}
            </a>
          </div>
          @if (!isNoProduct) {
            <sd-table
              [columns]="table.columns"
              [entries]="entries"
              [verticalLayout]="true"
              [maxLine]="numberOfLines"
              [showSize]="numberOfLinesToKeep"
              (more)="updateNumberOfLines()"
            />
          }
          @if (isNoProduct) {
            <p>
              {{ 'accessory.designedFor.noProductFound' | translate }}
              <a [routerLink]="contactUsUrl">{{ 'accessory.designedFor.consumerService' | translate }}</a>
            </p>
          }
        </ng-container>
      }
    </sd-component-wrapper>

    @defer (when isRefModalOpened) {
      <sd-modal-default
        [(isOpened)]="isRefModalOpened"
        [noPadding]="true"
        [modalTitle]="'accessory.search.modal.title' | translate"
        [modalTitleLevel]="4"
      >
        <div sd-modal-body>
          <div>{{ 'accessory.search.modal.text' | translate }}</div>
          <br />
          <div>{{ 'accessory.search.modal.example' | translate }}</div>
          <sd-banner [media]="{ url: urlImage }" style="max-width: 42.6rem; margin: 2rem auto 0" />
        </div>
      </sd-modal-default>
    }
  </div>
</div>
